import { IOrderPartyData, IOrderPartyResponse } from './IOrderParty';
import { UUID } from 'types/shared/UUID';
import {
  convertIAddressResponseToIPropertyAddressData,
  convertIPropertyAddressDataToIAddressResponse,
  IAddressResponse,
} from '../Address/IAddress';
import { undefConversion } from '../../../utilities/shared/undefinedConversion';
import { IPropertyAddressData } from '../../address/IPropertyAddressData';
import { ePartyType } from '../../../ui-toolkit/enums/ePartyType';

export interface IExternalAPIPersonPartyResponse extends IOrderPartyResponse {
  type: ePartyType.person;
  first_name: string;
  middle_name?: string;
  last_name: string;
  email?: string;
  phone_number?: string;
  ssn?: string;
  marital_status?: string;
  registered?: boolean;
  lender_user_id?: UUID;
  address?: IAddressResponse;
  date_of_birth?: string;
}

export interface IExternalAPIPersonPartyData extends IOrderPartyData {
  type: ePartyType.person;
  firstName: string;
  middleName?: string;
  lastName: string;
  email?: string;
  phoneNumber?: string;
  ssn?: string;
  maritalStatus?: string;
  registered?: boolean;
  lenderUserId?: UUID;
  address?: IPropertyAddressData;
  dateOfBirth?: string;
}

export const convertIExternalAPIPersonPartyResponseToIExternalAPIPersonPartyData = ({
  first_name,
  middle_name,
  last_name,
  phone_number,
  marital_status,
  lender_user_id,
  date_of_birth,
  address,
  ...rest
}: IExternalAPIPersonPartyResponse): IExternalAPIPersonPartyData => ({
  firstName: first_name,
  middleName: middle_name,
  lastName: last_name,
  phoneNumber: phone_number,
  maritalStatus: marital_status,
  lenderUserId: lender_user_id,
  dateOfBirth: date_of_birth,
  address: undefConversion(convertIAddressResponseToIPropertyAddressData, address),
  ...rest,
});

export const convertIExternalAPIPersonPartyDataToIExternalAPIPersonPartyResponse = ({
  firstName,
  middleName,
  lastName,
  phoneNumber,
  maritalStatus,
  lenderUserId,
  dateOfBirth,
  address,
  ...rest
}: IExternalAPIPersonPartyData): IExternalAPIPersonPartyResponse => ({
  first_name: firstName,
  middle_name: middleName,
  last_name: lastName,
  phone_number: phoneNumber,
  marital_status: maritalStatus,
  lender_user_id: lenderUserId,
  date_of_birth: dateOfBirth,
  address: undefConversion(convertIPropertyAddressDataToIAddressResponse, address),
  ...rest,
});
